import Footer from "./Footer";
import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import { BodyMarginManager } from "./BodyMarginManager";
import FloatingButtons from "./FloatingButtons";
import ErrorBoundary from "./ErrorBoundary";
const Layout = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleError = (error: Error, _: React.ErrorInfo) => {
    // Here you could send error to logging service
    console.log("Error caught by boundary:", error.message);
  };

  return (
    <>
      <ErrorBoundary onError={handleError}>
        <BodyMarginManager />
        <Navbar />
        <Outlet />
        <Footer />
        <FloatingButtons />
      </ErrorBoundary>
    </>
  );
};

export default Layout;
